(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-breadcrumbs-blog"] && !Shopify.designMode) return;
  try {
    const el = document.querySelector('.breadcrumbs-list');
  if (el && el.scrollWidth > el.clientWidth) {
    el.scrollTo({
      left: el.scrollWidth,
      behavior: 'smooth',
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class PriceRangeSlider extends HTMLElement {
    #minRange = null;
    #maxRange = null;
    #progress = null;
    #minInput = null;
    #maxInput = null;
    #syncingFromInputs = false;

    connectedCallback() {
      this.#minRange = this.querySelector('[ref="minRange"]');
      this.#maxRange = this.querySelector('[ref="maxRange"]');
      this.#progress = this.querySelector('[ref="progress"]');

      const facet = this.closest('price-facet-component');
      this.#minInput = facet?.querySelector('[ref="minInput"]') ?? null;
      this.#maxInput = facet?.querySelector('[ref="maxInput"]') ?? null;

      if (!this.#minRange || !this.#maxRange || !this.#minInput || !this.#maxInput) return;

      this.#minRange.addEventListener('input', this.#onRangeInput);
      this.#maxRange.addEventListener('input', this.#onRangeInput);
      this.#minRange.addEventListener('change', this.#onRangeChange);
      this.#maxRange.addEventListener('change', this.#onRangeChange);
      this.#minInput.addEventListener('change', this.#onInputChange);
      this.#maxInput.addEventListener('change', this.#onInputChange);
      document.addEventListener('filter:update', this.#onFilterUpdate);

      this.#syncFromInputs();
      this.#updateProgress();
    }

    disconnectedCallback() {
      this.#minRange?.removeEventListener('input', this.#onRangeInput);
      this.#maxRange?.removeEventListener('input', this.#onRangeInput);
      this.#minRange?.removeEventListener('change', this.#onRangeChange);
      this.#maxRange?.removeEventListener('change', this.#onRangeChange);
      this.#minInput?.removeEventListener('change', this.#onInputChange);
      this.#maxInput?.removeEventListener('change', this.#onInputChange);
      document.removeEventListener('filter:update', this.#onFilterUpdate);
    }

    #onRangeInput = (event) => {
      if (!this.#minRange || !this.#maxRange || !this.#minInput || !this.#maxInput) return;

      let minValue = Number(this.#minRange.value);
      let maxValue = Number(this.#maxRange.value);

      if (minValue > maxValue) {
        if (event.target === this.#minRange) {
          this.#minRange.value = String(maxValue);
          minValue = maxValue;
        } else {
          this.#maxRange.value = String(minValue);
          maxValue = minValue;
        }
      }

      if (event.target === this.#minRange) {
        this.#minRange.classList.add('is-active');
        this.#maxRange.classList.remove('is-active');
      } else {
        this.#maxRange.classList.add('is-active');
        this.#minRange.classList.remove('is-active');
      }

      this.#minInput.value = String(minValue);
      this.#maxInput.value = String(maxValue);
      this.#updateProgress();
    };

    #onRangeChange = () => {
      if (!this.#minInput || !this.#maxInput || this.#syncingFromInputs) return;

      this.#minInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    #onInputChange = () => {
      this.#syncFromInputs();
      this.#updateProgress();
    };

    #onFilterUpdate = () => {
      requestAnimationFrame(() => {
        this.#syncFromInputs();
        this.#updateProgress();
      });
    };

    #syncFromInputs() {
      if (!this.#minRange || !this.#maxRange || !this.#minInput || !this.#maxInput) return;

      const absMin = Number(this.dataset.min ?? 0);
      const absMax = Number(this.dataset.max ?? 0);
      let minValue = this.#parsePrice(this.#minInput.value, absMin);
      let maxValue = this.#parsePrice(this.#maxInput.value, absMax);

      minValue = Math.min(Math.max(minValue, absMin), absMax);
      maxValue = Math.min(Math.max(maxValue, absMin), absMax);

      if (minValue > maxValue) {
        const swap = minValue;
        minValue = maxValue;
        maxValue = swap;
      }

      this.#syncingFromInputs = true;
      this.#minRange.value = String(minValue);
      this.#maxRange.value = String(maxValue);
      this.#syncingFromInputs = false;
    }

    #updateProgress() {
      if (!this.#minRange || !this.#maxRange || !this.#progress) return;

      const absMin = Number(this.dataset.min ?? 0);
      const absMax = Number(this.dataset.max ?? 0);
      const span = absMax - absMin || 1;
      const minValue = Number(this.#minRange.value);
      const maxValue = Number(this.#maxRange.value);
      const left = ((minValue - absMin) / span) * 100;
      const right = ((maxValue - absMin) / span) * 100;

      this.#progress.style.left = `${left}%`;
      this.#progress.style.width = `${Math.max(right - left, 0)}%`;
    }

    #parsePrice(value, fallback) {
      if (!value || !value.trim()) return fallback;

      let normalized = value.replace(/\s/g, '');
      if (normalized.includes(',') && normalized.includes('.')) {
        if (normalized.indexOf(',') < normalized.indexOf('.')) {
          normalized = normalized.replace(/,/g, '');
        } else {
          normalized = normalized.replace(/\./g, '').replace(',', '.');
        }
      } else if (normalized.includes(',')) {
        normalized = normalized.replace(',', '.');
      }

      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? Math.round(parsed) : fallback;
    }
  }

  if (!customElements.get('price-range-slider')) {
    customElements.define('price-range-slider', PriceRangeSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
